module.exports = __webpack_public_path__ + "static/media/AB_A6_11.1377f217.jpg";